import {Alert} from '../functions'

document.addEventListener('DOMContentLoaded', function (e) {
    const object = vnObject

    const form = e.target.querySelector('.form')

    if (form) {
        const phoneNumber = form.querySelector('#tel')

        const regionsBtn = form.querySelectorAll('.js-region-btn')
        const regionInput = form.querySelector('.js-region-input')

        if (regionsBtn) {
            regionsBtn.forEach((regionBtn) => {
                regionBtn.addEventListener('click', () => {
                    regionsBtn.forEach((el) => {
                        el.classList.remove('active');
                    })
                    regionInput.value = regionBtn.dataset.value
                    regionBtn.classList.toggle('active')
                })
            })
        }

        form.addEventListener('submit', function (e) {
            e.preventDefault()
            e.stopPropagation()

            if (form.checkValidity()) {
                const formData = new FormData(form)
                formData.append('action', 'vn_form')

                const options = {
                    method: 'POST',
                    body: formData,
                    headers: {
                        Accept: 'application/json',
                    },
                }

                fetch(object.ajaxUrl, options)
                    .then((response) => response.json())
                    .then((res) => {
                        form.classList.remove('sending')

                        if (res.success && res.data.redirect) {
                            window.location = res.data.redirect
                        }

                        Alert(res.success, res.data.message)

                        if (res.success) {
                            form.reset()
                        }
                    })
                    .catch((error) => {
                        form.classList.remove('sending')
                        console.error('Erreur:', error)
                    })

                form.classList.add('sending')
                Alert(false, object.formWait)
            } else {
                form.classList.add('was-validated')
            }
        })
    }
})
